import React from 'react';
import {notification} from "antd";
import {getNotificationStyle} from "../constants/notificationStatus";

export const openNotification = (type, messageText, title) => {
    notification[type]({
        message: `${title}`,
        description:`${messageText}`,
        placement:"bottomRight",
        style: getNotificationStyle(type),
        duration: 2
    })
}